export const FINANCIAL_TRANSACTION_API_KEY = 'financial-transactions';

export const financialTransactionsApiQueryKeys = {
  all: () => [FINANCIAL_TRANSACTION_API_KEY] as const,
  byId: (id: string) => [FINANCIAL_TRANSACTION_API_KEY, id] as const,
  tableDefinition: () =>
    [FINANCIAL_TRANSACTION_API_KEY, 'table-definition'] as const,
};
